import { getCurrencySymbol } from '../functions/currency'
import isPopulated from '../functions/isPopulated'

export default function amountDisplayWithAbbreviation(
  amount: number | string,
  currency?: string,
  includeCurrency: boolean = true,
  showDecimals: boolean = true,
  decimalPlaces: number = 1
): string {
  const currencyString = includeCurrency && currency ? ` ${currency}` : ''

  if (!isPopulated(amount)) {
    return currency ? `${getCurrencySymbol(currency)} 0.00${currencyString}` : '0.00'
  }

  const numericAmount = parseFloat(amount.toString())

  if (Number.isNaN(numericAmount)) {
    return currency ? `${getCurrencySymbol(currency)} 0.00${currencyString}` : '0.00'
  }

  // Format large numbers with K, M, B abbreviations
  const formatWithAbbreviation = (num: number): string => {
    let formatted: string
    if (num >= 1000000000) {
      formatted = `${(num / 1000000000).toFixed(decimalPlaces)}B`
    } else if (num >= 1000000) {
      formatted = `${(num / 1000000).toFixed(decimalPlaces)}M`
    } else if (num >= 1000) {
      formatted = `${(num / 1000).toFixed(decimalPlaces)}K`
    } else {
      formatted = showDecimals ? num.toFixed(decimalPlaces) : Math.round(num).toString()
    }
    // Remove .0 from formatted values (e.g., "3.0K" -> "3K", but keep "2.3K" as is)
    return formatted.replace(/\.0([KMB])?$/, '$1')
  }

  const formattedAmount = formatWithAbbreviation(Math.abs(numericAmount))
  const sign = numericAmount < 0 ? '-' : ''

  if (currency) {
    return `${sign}${getCurrencySymbol(currency)} ${formattedAmount}${currencyString}`
  }

  return `${sign}${formattedAmount}`
}
